import type { ProgressRepository } from "@/domain";

import { InMemoryProgressRepository } from "./in-memory-progress-repository";
import {
  IndexedDbProgressRepository,
  type IndexedDbProgressRepositoryOptions
} from "./indexeddb-progress-repository";

export type ProgressStorageMode = "indexeddb" | "memory";

export interface ProgressRepositoryHandle {
  repository: ProgressRepository;
  storageMode: ProgressStorageMode;
  isPersistent: boolean;
  initializationError?: Error;
}

export async function createProgressRepository(
  options: IndexedDbProgressRepositoryOptions = {}
): Promise<ProgressRepositoryHandle> {
  try {
    if (globalThis.indexedDB === undefined) {
      throw new Error("IndexedDB is unavailable in this environment.");
    }

    const repository = new IndexedDbProgressRepository(options);
    await repository.initialize();
    return {
      repository,
      storageMode: "indexeddb",
      isPersistent: true
    };
  } catch (error) {
    const initializationError =
      error instanceof Error
        ? error
        : new Error("IndexedDB initialization failed.", { cause: error });

    return {
      repository: new InMemoryProgressRepository(),
      storageMode: "memory",
      isPersistent: false,
      initializationError
    };
  }
}
